import { format, subDays } from 'date-fns';

// Días hacia atrás que el admin puede elegir como fecha de pago.
// Debe coincidir con FechaPagoAdmin::DIAS_RETROACTIVOS en el backend.
export const DIAS_RETROACTIVOS_PAGO = 7;

export const rangoFechaPago = () => {
  const hoy = new Date();
  return {
    min: format(subDays(hoy, DIAS_RETROACTIVOS_PAGO), 'yyyy-MM-dd'),
    max: format(hoy, 'yyyy-MM-dd'),
  };
};
